import React from 'react'

function PopOver({children}) {
  return (
    <div className='popoverdiv'>
        {children}
    </div>
  )
}

export default PopOver